import moment from 'moment'

export default {
    namespaced: true,
    state: {
        groupIndex: 0,
        reportTab: 0,
        reportId: null,
        graphType: 'actual',
        granularity: 'week',
        tab: 0,
        tabs: [
            {
                text: 'Status',
                icon: 'fa-list'
            },
            {
                text: 'Udvikling',
                icon: 'fa-chart-line'
            },
            {
                text: 'Service',
                icon: 'fa-headphones-alt'
            },
            {
                text: 'Emner',
                icon: 'fa-users'
            }
        ],
        period: 'Denne uge',
        presets: [
            "I dag",
            "I går",
            "Denne uge",
            "Sidste uge",
            "Denne måned",
            "Sidste måned",
            "Dette år",
            "Selvvalgt"
        ],
        range: [
            moment()
                .subtract(30, "days")
                .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
        ],
        chartOptions: {
            xaxis: {
                categories: []
            },
            chart: {
                animations: {
                    enabled: false
                },
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                        customIcons: []
                    }
                }
            },
            grid: {
                xaxis: {
                    lines: {
                        show: true
                    }
                }
            }
        }
    },
    mutations: {
        setRange: (state, preset) => {
            if (preset === "Seneste 30 dage") {
                state.range = [
                    moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            }
            else if (preset === "I dag") {
                state.range = [
                    moment()
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "I går") {
                state.range = [
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne uge") {
                state.range = [
                    moment()
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste uge") {
                state.range = [moment()
                        .subtract(1, "weeks")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "weeks")
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne måned") {
                state.range = [
                    moment()
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste måned") {
                state.range = [
                    moment()
                        .subtract(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Dette år") {
                state.range = [
                    moment()
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                    moment()
                        .format("YYYY-MM-DD")
                ];
            }
        },
        setChartOptions: (state, {
            formatter: formatter,
            categories: categories
        }) => {
            state.chartOptions = {
                ...state.chartOptions,
                xaxis: {
                    categories: categories
                },
                dataLabels: {
                    enabled: true,
                    formatter: formatter
                }
            };
            state.categories = categories
        }
    },
    getters: {
        tab: state => state.tabs[state.tab],
        currentReport: state => state.reports[state.reportTab] || {},
        campaigns: (state, getters) => {
            if (getters.currentReport.type === 'grouped') {
                if (state.groupIndex === 0) return getters.currentReport.campaigns
                else return getters.currentReport.groups[state.groupIndex - 1].campaigns
            }
            else {
                return getters.currentReport.campaigns
            }
        }
    }
}